import React, { useState, useEffect } from "react";
import { List, Modal, notification, Image, Row, Col, Select, Spin } from "antd";

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
// import datas from "./data";

// import VirtualList from "rc-virtual-list";
import http from "../../../../helpers/http";

import { DragHandle } from "../../../../components/DragHandle";
import { Option } from "antd/lib/mentions";
import axios from "axios";

const Ordering = ({
  isOpen,
  onClose,
  categories,
  moduleName,
  isMobile,
  image_url,
  base_url,
}) => {
  const [datalist, setdatalist] = useState([]);
  const [categorylist, setCategorylist] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState();
  const [loading, setloading] = useState(false);
  const [fetching, setFetching] = useState(false);

  useEffect(() => {
    setCategorylist(categories);
    setSelectedCategory(categories[0]?.title);
  }, [categories]);

  useEffect(() => {
    const fetchProducts = async () => {
      setFetching(true);
      try {
        const data = await axios({
          method: "get",
          url: base_url + `/byCategory/${selectedCategory}`,
          // withCredentials: true,
        });
        if (data?.data) {
          setdatalist(data.data);
        }
      } catch (err) {
        console.log(err);
        setdatalist([]);
      }
      setFetching(false);
    };
    if (isOpen) fetchProducts();
  }, [selectedCategory, isOpen]);

  const handleOrder = async (updatedData) => {
    const payload = {
      products: updatedData.map((item, idx) => ({
        _id: item._id,
        sort_order: idx,
      })),
    };
    setloading(true);
    const { data } = await http.put(`${base_url}/sort`, payload);
    if (data) {
      notification["success"]({
        message: `${moduleName} Sorting Updated Successfully`,
      });
      onClose();
    }
    setloading(false);
  };

  return (
    <>
      <Modal
        title="Products Ordering"
        visible={isOpen}
        onOk={() => {
          handleOrder(datalist);
        }}
        okText="Update"
        confirmLoading={loading}
        onCancel={onClose}
      >
        <Row gutter={12} style={{ marginBottom: 16 }}>
          <Col span={12}>
            <>
              <p>Select Category</p>
              <Select
                placeholder="Select Category"
                value={selectedCategory}
                onChange={setSelectedCategory}
                style={{ width: "100%" }}
                // allowClear
                // disabled={showFeatured}
              >
                {categorylist &&
                  categorylist.map((cat) => (
                    <Option key={cat._id} value={cat.title}>
                      {cat.title}
                    </Option>
                  ))}
              </Select>
            </>
          </Col>
        </Row>
        {fetching ? (
          <Spin style={{ width: "100%" }} />
        ) : (
          <DragDropContext
            onDragEnd={(param) => {
              // const id = param.draggableId;
              const srcI = param.source.index;
              const sort_order = param.destination?.index;

              console.log(param);
              if (sort_order !== undefined) {
                // handleOrder(id,sort_order);
                let temparray = [...datalist];
                temparray.splice(sort_order, 0, temparray.splice(srcI, 1)[0]);
                console.log(temparray);
                setdatalist(temparray);
                //   datas.saveList(datalist);
              }
            }}
          >
            <div>
              <Droppable droppableId="droppable-1">
                {(provided, _) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    style={{ maxHeight: 400, overflow: "auto" }}
                  >
                    <List
                      // footer={<div>Footer</div>}
                      bordered
                      dataSource={datalist}
                      renderItem={(item, i) => (
                        <>
                          <Draggable
                            key={item._id}
                            draggableId={item._id}
                            index={i}
                          >
                            {(provided, snapshot) => (
                              <div ref={provided.innerRef}>
                                <List.Item
                                  {...provided.draggableProps}
                                  style={{
                                    ...provided.draggableProps.style,
                                    boxShadow: snapshot.isDragging
                                      ? "0 0 .4rem #666"
                                      : "none",
                                  }}
                                >
                                  <Image
                                    width={80}
                                    src={image_url + item.desktopImageUrl}
                                    preview={{
                                      scaleStep: 0.1,
                                      minScale: 0.1,
                                      maxScale: 1,
                                    }}
                                    // fallback="https://via.placeholder.com/100"
                                  />
                                  <span style={{ marginLeft: 16 }}>
                                    {item.title}
                                  </span>
                                  <DragHandle {...provided.dragHandleProps} />
                                </List.Item>
                              </div>
                            )}
                          </Draggable>
                        </>
                      )}
                    />

                    {/* {datalist.map((item, i) => (
                  <Draggable
                    key={item.id}
                    draggableId={"draggable-" + item.id}
                    index={i}
                  >
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        style={{
                          ...provided.draggableProps.style,
                          boxShadow: snapshot.isDragging
                            ? "0 0 .4rem #666"
                            : "none",
                        }}
                      >
                        <DragHandle {...provided.dragHandleProps} />
                        <span>{item.title}</span>
                      </div>
                    )}
                  </Draggable>
                ))} */}

                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </div>
          </DragDropContext>
        )}
      </Modal>
    </>
  );
};

export default Ordering;
